new Vue({
    el:'.egyptGiveaway',
    data(){
        return{
            // 加载完成
            loadFlag:false,
            loginFlag:false,
            popup:false,
            lotteryPopup:false,
            qrCodePopup:false,
            loginPopup:false,
            isLogin:false,
            user:{
                name:'',
                email:'',
                verify_code:'',
                phone:''
            },
            admin:{
                user:'',
                passward:''
            },
            submitFlag:false,
            flag: false,
            TextNum1:0,
            TextNum2:0,
            TextNum3:0,
            intId: [],
            btnImg:[
                'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/btnStart_687f2b74-6a50-4868-b61b-0a70ba104c25.png?v=1764647437',
                'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/btnStop_a12a1406-afb2-41d9-8eb6-d35d58ccd33b.png?v=1764647438'
            ],
            btnIndex:0,
            heightNum:130,
            navId:0,
            navText:['الجولة الأولى','الجولة الثانية'],
            prizeData:{},
            leftCount:{
                num1:20,
                num2:20,
            },
            // 中奖提示
            show:false,
            showType:1
        }
    },
    methods:{
        // 功能类------------------------------------------------
        async loginActivity(){
            if(!this.user.name || !this.user.email || !this.user.phone || !this.user.verify_code){
                showMessage('يرجى ملء المعلومات بشكل كامل.','error')
                return;
            }
            // 邮箱正则表达式
            var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if(!emailReg.test(this.user.email)){
                showMessage('خطأ في تنسيق البريد الإلكتروني','error')
                return;
            }
            showMessage('جاري الإرسال، الرجاء الانتظار...','success')
            //避免重复提交 
            if(this.loginFlag) return;
            this.loginFlag = true
            var params=new URLSearchParams();
            params.append('info',JSON.stringify(this.user));
            let res = await axios.post('https://service.oxvatech.cn/trifusion/egyptLogin',params);
            if(res.data.status == 200){
                this.user.id = res.data.data
                this.isLogin = true
                showMessage('تم الإرسال بنجاح','success')
            }else{
                this.loginFlag = false
                let errorMessages = {
                    201: 'رقم المنتج غير موجود',
                    202: 'اسم المستخدم موجود بالفعل',
                    203: 'لقد تم استخدام رمز المنتج هذا بالفعل',
                    204: 'عنوان البريد الإلكتروني موجود بالفعل.',
                    500:' خطأ في الخادم، يرجى الاتصال بخدمة العملاء',
                };
                showMessage(errorMessages[res.data.status] || 'Unknown error', 'error');
            }
        },
        async adminLogin(){
            if(!this.admin.user || !this.admin.passward){
                showMessage('يرجى ملء المعلومات بشكل كامل.','error')
                return;
            }
            var params=new URLSearchParams();
            params.append('info',JSON.stringify(this.admin));
            let res = await axios.post('https://service.oxvatech.cn/trifusion/adminLogin',params);
            if(res.data.status==200){
                this.loginPopup=false;
                this.lotteryPopup=true;
                showMessage('تم تسجيل الدخول بنجاح','success')
            }else{
                showMessage('اسم المستخدم أو كلمة المرور غير صحيحة.','error')
            }
        },
        async lottery(){
            var params=new URLSearchParams();
            params.append('info',JSON.stringify({id:this.navId+1}));
            let res = await axios.post('https://service.oxvatech.cn/trifusion/lottery', params);

            if(res.data.status==200){
                this.showType=1
                this.prizeData = res.data.data
                this.leftCount[`num${this.navId+1}`] = this.prizeData.leftCount
                this.prizeData.prizeName = this.getPrizeName(this.prizeData.number)
                this.splitNumber(this.prizeData.winUserId)
            }else if(res.data.status==201){
                //奖池已空
                this.showType=2
                showMessage('يا عزيزي، لم تعد هناك مشاركات في السحب المحظوظ!','error')
            }else if(res.data.status==202){
                //没有用户
                this.showType=3
                showMessage('لم يتبق أي مستخدمين.','error')
            }
        },
        async getCount(){
            let res = await axios.get('https://service.oxvatech.cn/trifusion/getCount');
            if(res.data.status==200){
                this.leftCount.num1 = res.data.data.num1
                this.leftCount.num2 = res.data.data.num2
            }
        },
        // 工具类-------------------------------------------------
        startLottery(){
            let _this = this
            if (!this.flag) {
                this.show = false
                if(this.leftCount[`num${this.navId+1}`]==0){ 
                    showMessage('يا عزيزي، لم تعد هناك مشاركات في السحب المحظوظ!','error')
                    return;
                }
                this.lottery()
                this.flag = true;
                this.reset();
                this.letGo();
                this.btnIndex = 1
            } else {
                this.stopGo();
                setTimeout(function(){
                    _this.btnIndex = 0
                    _this.flag = false;
                },100)
            }
        },    
        letGo(){
            this.loop(0,".num-con1")
            this.loop(1,".num-con2")
            this.loop(2,".num-con3")
        },
        loop(idx, element){
            let _this = this
            this.intId[idx] = setInterval(function () {
                $(element).animate({
                    'top': '-=20'
                }, 0, function () {
                    var s = Math.abs(parseInt($(this).css("top")));
                    if (s >= _this.heightNum*10) {
                        $(this).find("ul").slice(0, 1).appendTo($(this));
                        $(this).css("top", 0);
                    }
                });
            }, 1)
        },
        stopGo(){
            clearInterval(this.intId[0])
            clearInterval(this.intId[1])
            clearInterval(this.intId[2])
            //this.TextNum1 = parseInt(Math.random() * 10)//随机数
            //this.TextNum2 = parseInt(Math.random() * 10)
            //this.TextNum3 = parseInt(Math.random() * 10)
            // this.TextNum1 = 2//指定数
            // this.TextNum2 = 3
            // this.TextNum3 = 8
    
            var num1 = [-(this.heightNum * 10), -(this.heightNum * 11), -(this.heightNum * 12), -(this.heightNum * 13), -(this.heightNum * 14), -(this.heightNum * 15), -(this.heightNum * 16), -(this.heightNum * 17), -(this.heightNum * 18), -(this.heightNum * 19),][this.TextNum1];//在这里随机
            var num2 = [-(this.heightNum * 10), -(this.heightNum * 11), -(this.heightNum * 12), -(this.heightNum * 13), -(this.heightNum * 14), -(this.heightNum * 15), -(this.heightNum * 16), -(this.heightNum * 17), -(this.heightNum * 18), -(this.heightNum * 19),][this.TextNum2];
            var num3 = [-(this.heightNum * 10), -(this.heightNum * 11), -(this.heightNum * 12), -(this.heightNum * 13), -(this.heightNum * 14), -(this.heightNum * 15), -(this.heightNum * 16), -(this.heightNum * 17), -(this.heightNum * 18), -(this.heightNum * 19),][this.TextNum3];
    
            this.pubAnimate(".num-con1", num1)
            this.pubAnimate(".num-con2", num2)
            this.pubAnimate(".num-con3", num3)
            
            this.show = true
        },
        pubAnimate(el,num){
            $(el).animate({ "top": 0 }, 0, "linear", function () {
                $(this).css("top", 0).animate({ "top": num }, 0, "linear");
            });
        },
        reset(){
            $(".num-con1,.num-con2,.num-con3").css({ "top": 0 });
        },
        setCookie(name,value,day){
            var d = new Date();
            d.setTime(d.getTime() + (day * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = name + "=" + value + ";" + expires + ";path=/";
        },
        getCookie(name){
            var name = name + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var cookieArray = decodedCookie.split(';');
            for(let i = 0; i < cookieArray.length; i++) {
                let cookie = cookieArray[i];
                while (cookie.charAt(0) == ' ') {
                    cookie = cookie.substring(1);
                }
                if (cookie.indexOf(name) == 0) {
                    return cookie.substring(name.length, cookie.length);
                }
            }
            return "";
        },
        // 扫描二维码识别数字
        qrCode(){
            var that = this
            this.popup = this.qrCodePopup = true
            setTimeout(() => {
                let html5QrCode = new Html5Qrcode("qr-reader");
                html5QrCode.start(
                    { facingMode: "environment" }, // 后置摄像头
                    {
                        fps: 10,
                        qrbox: 250,
                    },
                    (decodedText) => {
                        // 停止扫描
                        html5QrCode.stop().then(() => {
                        });

                        // 提取数字
                        const numbers = decodedText.match(/\d+/g);
                        that.popup = that.qrCodePopup = false
                        that.user.verify_code = numbers.join(", ")
                    }
                ).catch(err => {
                    
                });
            }, 300);
        },
        // 奖项函数
        getPrizeName(num) {
            if (num === 1) return "الجائزة الاولى：جهاز بلي ستيشن 5 سلم";
            if (num === 2) return "الجائزة الثانية：مکبر صوت بلوتوث مارشال";
            if (num === 3) return "الجائزة الثالثة：ذهب خالص";
            return "الجائزة الرابعة：بطاقات تسوق/ مجموعة هدايا اوکسبار"; // 4-20
        },
        splitNumber(n) {
            // 转为字符串，保证可逐位处理
            const str = String(n).padStart(3, '0'); // 不足三位前面补 0
            this.TextNum1 = Number(str[str.length - 3]) // 百位
            this.TextNum2 = Number(str[str.length - 2]) // 十位
            this.TextNum3 = Number(str[str.length - 1]) // 个位
        }
    },
    created(){
        // 加载完成后 更新弹窗显示样式
        this.loadFlag = true

        if(window.location.href.indexOf('?type=administrator-account') != -1){
            this.popup=this.loginPopup=true
        }

        this.getCount()
    },
    mounted(){
        var wFlag=window.innerWidth>750
        if(!wFlag){
            this.heightNum = 76
        }
        function showUp(dom){
            gsap.from(dom,{
                y:'2rem',opacity:0,ease:'none',duration:0.5,
                scrollTrigger:{
                    trigger:dom,
                    start:'top bottom-=20%',
                    end:'+=0',
                    toggleActions:'play none none reverse',
                }
            })
        }

        setTimeout(() => {
            $('.box1_title').addClass('showup')
        }, 300);
    }
})


// 1,2,3,4,5,6,7,8,9,10,12,13,14,15,16,17,18,19,20